
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'EventPeriod',

	props: {
		dateFrom: {
			type: String,
			required: true
		},
		timeFrom: {
			type: String,
			required: true
		},
		dateTo: {
			type: String,
			required: true
		},
		timeTo: {
			type: String,
			required: true
		},
		entryTime: {
			type: String,
			required: true
		},
		timeZone: {
			type: String,
			required: true
		},

		onlyStartDateShown: {
			type: Boolean,
			default: false
		},

		eventStartDateInfo: {
			type: Object,
			default: () => {}
		}
	}
})
